module.exports = require("front-markjs");